// src/services/visitorService.ts
import { supabase } from './supabase';

export interface VisitorStats {
    today: number;
    total: number;
}

class VisitorService {
    private readonly VISITOR_KEY = 'ruyo_last_visit';

    // Получить статистику
    async getStats(): Promise<VisitorStats> {
        try {
            const today = new Date().toISOString().split('T')[0];

            // Получаем сегодняшние посещения
            const { data: todayData, error: todayError } = await supabase
                .from('visitors')
                .select('visitor_count')
                .eq('visit_date', today)
                .single();

            if (todayError && todayError.code !== 'PGRST116') {
                console.error('Error fetching today stats:', todayError);
            }

            // Получаем общее количество
            const { data: totalData, error: totalError } = await supabase
                .from('total_visitors')
                .select('total_count')
                .eq('id', 1)
                .single();

            if (totalError) {
                console.error('Error fetching total stats:', totalError);
            }

            return {
                today: todayData?.visitor_count || 0,
                total: totalData?.total_count || 0
            };
        } catch (error) {
            console.error('Error in getStats:', error);
            return { today: 0, total: 0 };
        }
    }

    // Отследить посещение
    async trackVisit(): Promise<void> {
        try {
            const today = new Date().toISOString().split('T')[0];
            const lastVisit = localStorage.getItem(this.VISITOR_KEY);

            // Если уже был сегодня, не отслеживаем
            if (lastVisit === today) {
                return;
            }

            // 1. Обновляем или создаем запись за сегодня
            const { data: existing } = await supabase
                .from('visitors')
                .select('id, visitor_count')
                .eq('visit_date', today)
                .single();

            if (existing) {
                // Обновляем существующую запись
                await supabase
                    .from('visitors')
                    .update({ visitor_count: existing.visitor_count + 1 })
                    .eq('id', existing.id);
            } else {
                // Создаем новую запись
                await supabase
                    .from('visitors')
                    .insert([{ visit_date: today, visitor_count: 1 }]);
            }

            // 2. Обновляем общий счетчик
            const { data: totalData } = await supabase
                .from('total_visitors')
                .select('total_count')
                .eq('id', 1)
                .single();

            await supabase
                .from('total_visitors')
                .update({ total_count: (totalData?.total_count || 0) + 1 })
                .eq('id', 1);

            // Сохраняем дату посещения
            localStorage.setItem(this.VISITOR_KEY, today);

        } catch (error) {
            console.error('Error tracking visit:', error);
        }
    }
}

export const visitorService = new VisitorService();